import React, {Suspense, useEffect, useState, lazy} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {getRunTime, getRunTimeBasic} from "../../store/actionsCreator/flyerActionsCreator";
import {Layout} from "../layout";
import {
    setPortraitView,
    toggleBasket,
    toggleMultipage
} from "../../store/actionsCreator/controlsActionsCreator";
import {Helmet} from "react-helmet";
import {isDesktop, isMobile, isTablet} from 'react-device-detect';
import {
    IFlyerRuntimePage, IFlyerRuntimePageSpot,
    IFlyerRuntimePageSpotItem, IFlyerRuntimePageSpotPromo,
    IFreeItemDto,
    IFreeItemsInPromo,
    ItemState, MyListDto, ParamTypesDto,
    PromosState
} from "../../dtos/flyer";
import {Route, Switch, useHistory} from "react-router-dom";
import {getMyListForFlyer} from "../../store/actionsCreator/myListForFlyerActionCreator";
import {useParams} from 'react-router-dom';
import {
    timeLog
} from "../../com/globalsFunctions/globalFunctions";
import {changeEasterEggDataDispatcher} from "../../store/actionsCreator/changeEasterEggDataCreator";
import {changeMyListItemsAndBenefitItemsAction} from "../../store/actionsCreator/myListActionsCreator";
import {changeMyListData} from "../../store/actionsCreator/changeMyListDataActionCreator";
import {Loading} from "../loading";
// import FlyerNotFoundModal from "./FlyerNotFoundModal";
// import ExpiredFlyerScreen from "../expiredFlyerScreen/expiredFlyerScreen";
import DesktopView from "../../views/desktop/desktopView";
import ReduxErrorHandler from "../reduxErrorHandler/reduxErrorHandler";
// import SmartphoneView from "../../views/smartphone/smartphoneView";
// import DisclaimerPopup from "../disclaimerPopup/disclaimerPopup";
// import QuickTipsPopup from "../quickTipsPopup/quickTipsPopup";
// import ChangeMyListPopup from "../changeMyListPopup/changeMyListPopup";
// import ProgressBarPopup from "../../com/progressBarPopup/progressBarPopup";
// import ReduxErrorHandler from "../reduxErrorHandler/reduxErrorHandler";


// const DesktopView = lazy(() => import("../../views/desktop/desktopView"));
const SmartphoneView = lazy(() => import("../../views/smartphone/smartphoneView"));
const DisclaimerPopup = lazy(() => import("../disclaimerPopup/disclaimerPopup"));
const QuickTipsPopup = lazy(() => import("../quickTipsPopup/quickTipsPopup"));
const ChangeMyListPopup = lazy(() => import("../changeMyListPopup/changeMyListPopup"));
// const ReduxErrorHandler = lazy(() => import("../reduxErrorHandler/reduxErrorHandler"));
// const ProgressBarPopup = lazy(() => import("../../com/progressBarPopup/progressBarPopup"));
const ExpiredFlyerScreen = lazy(() => import("../expiredFlyerScreen/expiredFlyerScreen"));
const FlyerNotFoundModal = lazy(() => import("./FlyerNotFoundModal"));


interface Props {
    startTime: number;
}

const ShopperMain: React.FC<Props> = ({startTime}) => {
    const dispatch = useDispatch();
    const {
        controlsBranch,
        flyersBranch,
        changedMyList,
        flyerBranchBasic,
        myListForFlyer,
        easterEggDataFromStore,
        myListState
    } = useSelector((state: IAppState) => state);
    const {isLoading} = flyersBranch;
    const [isMyListChanged, setMyListChangeStatus] = useState<boolean>(changedMyList.isChanged);
    // const isHebrewStyle = flyers?.dir === "RTL";
    let history = useHistory();
    // const isMobileWidth = useMediaQuery("(max-width:767px)", { noSsr: true });

    // const {i18n} = useTranslation();
    const {
        isMultipage,
        isPortraitView
    } = controlsBranch;

    if (isMobile && isMultipage) {
        // console.log('isMultipage',isMultipage);
        dispatch(toggleMultipage())
        // console.log('isMultipage',isMultipage);
    }
    const {accountName, flyerName} = useParams<ParamTypesDto>();

    // const accountName = window.location.pathname.split('/').filter((key: string) => {
    //     if (key !== '') {
    //         return key;
    //     }
    // })[0];
    // const flyerName = window.location.pathname.split('/').filter((key: string) => {
    //     if (key !== '') {
    //         return key;
    //     }
    // })[1];
    // const pageNumber = window.location.pathname.split('/').filter((key: string) => {
    //     if (key !== '') {
    //         return key;
    //     }
    // })[2];
    const [showFlyerNotFoundModal, toggleFlyerNotFoundModal] = useState(false);
    const [isShowDisclaimer, changeStatusOfDisclaimer] = useState<boolean>(false);
    const [isShowQuickTipsPopup, changeStatusOfQuickTipsPopup] = useState<boolean>(false);
    const [isShowChangeMyListPopup, changeStatusOfMyListPopup] = useState<boolean>(false);
    // const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    // const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;

    useEffect(() => {
        window.addEventListener('resize', () => {
            if (isDesktop) {
                if (window.innerWidth > window.innerHeight && window.innerWidth > 800) {
                    dispatch(setPortraitView(false));
                } else {
                    dispatch(setPortraitView(true));
                }
            }
        }, {passive: false})
        return () => {
            window.removeEventListener('resize', () => {
            });
        }
    }, []);

    useEffect(() => {
        window.addEventListener('beforeunload', beforeClose);
        return () => {
            window.removeEventListener('beforeunload', beforeClose);
        }
    });

    useEffect(() => {
        if (!isShowDisclaimer && flyersBranch.data && flyersBranch.data.flyerUiTexts?.isQuickTips) {
            changeStatusOfQuickTipsPopup(true);
        }
    }, [isShowDisclaimer]);

    useEffect(() => {
        runChangeMyList();
        if (myListForFlyer.type === "GET_MY_LIST_FOR_FLYER_ERROR") {
            if (Boolean(history.location.search)) {
                history.push(`${history.location.pathname}${history.location.search}`);
            } else {
                history.push(history.location.pathname);
            }

        }

    }, [myListForFlyer]);

    useEffect(() => {
        setMyListChangeStatus(changedMyList.isChanged);
    }, [changedMyList]);


    const beforeClose = (event: any) => {
        alertUser(event);
        localStorage.setItem(`basketpromos${flyersBranch.data?.id}`, JSON.stringify(myListState.promos));
        localStorage.setItem(`freeItemsForFlyer${flyersBranch.data?.id}`, JSON.stringify(myListState.benefitItems));
    }


    const alertUser = (event: any) => {
        if (isMyListChanged && myListState.promos.length !== 0) {
            event.preventDefault();
            event.returnValue = "";
            return "";
        }
    }

    useEffect(() => {
        if (flyersBranch.data?.isFirstActivationSinceDeployment) {
            localStorage.clear();
        }
        console.log(flyersBranch.data?.languageCultureCode);
        if (flyersBranch.data?.font) {
            document.documentElement.style
                .setProperty('--main-theme-font', `${flyersBranch.data?.font.toLowerCase()}`);
            document.documentElement.style
                .setProperty('--main-theme-font-bold', `${flyersBranch.data?.font.toLowerCase()}-bold`);

            // document.getElementsByTagName('body')[0].classList.add(flyersBranch.data?.font.toLowerCase());
        }
        //set theme color for project
        if (flyersBranch.data?.primaryColorRgb) {
            document.documentElement.style
                .setProperty('--main-theme-opacity-color', `${flyersBranch.data?.primaryColorRgb}33`);
            document.documentElement.style
                .setProperty('--main-theme-opacity-color-op5', `${flyersBranch.data?.primaryColorRgb}80`);
            document.documentElement.style
                .setProperty('--main-theme-opacity-color-op7', `${flyersBranch.data?.primaryColorRgb}B3`);

            document.documentElement.style
                .setProperty('--main-theme-color', `${flyersBranch.data?.primaryColorRgb}`);

        }
        //google tags required attr
        document.body.setAttribute("data-xcenvironment", flyersBranch.data?.environment || "")

        if (flyersBranch.data?.caption) {
            document.title = flyersBranch.data?.caption!;
        }
        const isShowDisclaimer = Boolean(flyersBranch.data && flyersBranch.data?.disclaimers && Boolean(flyersBranch.data?.disclaimers?.isFlyerDisclaimer))
        if (isShowDisclaimer) {
            changeStatusOfDisclaimer(isShowDisclaimer);
        } else if (!isShowDisclaimer && flyersBranch.data && flyersBranch.data.flyerUiTexts?.isQuickTips) {
            changeStatusOfQuickTipsPopup(true);
        } else {
            runChangeMyList()
        }
        const timeString = timeLog('From the beginning to the end of rendering the flyer (WM GetFlyerRuntime includes):', startTime);
        dispatch(changeEasterEggDataDispatcher({
            ...easterEggDataFromStore,
            flyerRenderTimeWithLabelInString: timeString
        }));

        //get mylist promos and items from storage
        const myListPromosString = localStorage.getItem(`basketpromos${flyersBranch.data?.id}`);
        //parse data from storage to PromosState[]
        const parsedMyListPromos = myListPromosString ? JSON.parse(myListPromosString) : [];
        // Map over each promo in the parsed My List promos
        const changedPromosForMyList: PromosState[] = parsedMyListPromos.map((myListPromo: PromosState) => {
            // Initialize the promo object from the flyer to an empty object
            const promoFromFlyer = flyersBranch.data?.pages.flatMap((page: IFlyerRuntimePage) => {
                // Find the first spot that matches the promoId in the current My List promo
                const pageFrame = page.spots.find((spot: IFlyerRuntimePageSpot) => spot.promo?.promoId === myListPromo.promoId);
                // If no spot is found, return an empty array to flatMap
                if (!pageFrame) {
                    return [];
                }
                // Map over the items array in the current My List promo
                const updatedItems = myListPromo.items.map((myListItem: ItemState) => {
                    // Find the item in the promo that matches the item ID in the current My List item
                    const itemFromFlyer = pageFrame.promo?.items.find((item: IFlyerRuntimePageSpotItem) => item.id === myListItem.spotItem.id);
                    // If no item is found, return the current My List item as is
                    if (!itemFromFlyer) return myListItem;
                    // Return a new object that combines the current My List item with the item from the flyer promo
                    return {...myListItem, spotItem: itemFromFlyer};
                });
                // Return a new object that combines the promo from the flyer with the updated items array from the My List promo
                return {...pageFrame.promo, items: updatedItems};
            })[0] || {};
            // Return a new object that combines the current My List promo with the promo object from the flyer
            return {...myListPromo, ...promoFromFlyer};
        });
        //get mylist benefit items from storage
        const myListBenefitItems = localStorage.getItem(`freeItemsForFlyer${flyersBranch.data?.id}`);
        //parse data from storage to IFreeItemsInPromo[]
        const parsedMyListBenefitItems = myListBenefitItems ? JSON.parse(myListBenefitItems) : [];
        // Map over each benefit promo in the parsed My List benefit items
        const changedMyListBenefitItems: IFreeItemsInPromo[] = parsedMyListBenefitItems.map((myListBenefitPromo: IFreeItemsInPromo) => {
            // Initialize the promo object from the flyer to an empty object
            const promoFromFlyer = flyersBranch.data?.pages.flatMap((page: IFlyerRuntimePage) => {
                // Find the first spot that matches the promoId in the current benefit promo
                const pageFrame = page.spots.find((spot: IFlyerRuntimePageSpot) => spot.promo?.promoId === myListBenefitPromo.promoId);
                // If no spot is found, return an empty array to flatMap
                if (!pageFrame) {
                    return [];
                }
                // Map over the freeItems array in the current benefit promo
                const updatedItems = myListBenefitPromo.freeItems?.map((myListBenefitItem: IFreeItemDto) => {
                    // Find the item in the promo that matches the itemID in the current benefit item
                    const itemFromFlyer = pageFrame.promo?.items.find((item: IFlyerRuntimePageSpotItem) => item.id === myListBenefitItem.itemID);
                    // If no item is found, return the current benefit item as is
                    if (!itemFromFlyer) return myListBenefitItem;
                    // Return a new object that combines the current benefit item with the display caption from the flyer item
                    return {...myListBenefitItem, benefitItemCaption: itemFromFlyer.displayCaption1};
                });
                // Return a new object that combines the current benefit promo with the updated freeItems array from the flyer
                return {...myListBenefitPromo, freeItems: updatedItems};
            })[0] || {};
            // Return a new object that combines the current benefit promo with the promo object from the flyer
            return {...myListBenefitPromo, ...promoFromFlyer};
        });
        //set data
        const data: MyListDto = {
            promos: changedPromosForMyList,
            benefitItems: changedMyListBenefitItems
        }
        //apply changes to state
        dispatch(changeMyListItemsAndBenefitItemsAction(data));
    }, [flyersBranch.data]);

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const allSearchParams = Object.fromEntries(urlSearchParams.entries());
        if (flyersBranch.type === "GET_FLYER_RUNTIME_SUCCESS" && allSearchParams.FlyerItemListId) {
            // flyersBranch.data?.id
            dispatch(getMyListForFlyer(Number(allSearchParams.FlyerItemListId), flyersBranch.data ? flyersBranch.data.id : -1));
        }
    }, [flyersBranch]);

    useEffect(() => {
        if (!accountName && !flyerName) {
            toggleFlyerNotFoundModal(true);
        } else {
            // const generateCustomNumbersId = (min: number, max: number) => {
            //     return Math.round(Math.random() * (max - min) + min);
            // }
            dispatch(getRunTimeBasic(accountName, flyerName));
        }
    }, [accountName, flyerName, showFlyerNotFoundModal]);


    useEffect(() => {
        if (flyerBranchBasic.data) {
            if (flyerBranchBasic.data.isValid) {
                if (flyerBranchBasic.data.isFirstActivationSinceDeployment) {
                    localStorage.clear();
                }
                const shopperDataWithId = localStorage.getItem('FlyerShopperId');
                const basketWithId = localStorage.getItem('BasketId');
                let flyerShopperId: number;
                if (shopperDataWithId) {
                    flyerShopperId = Number(localStorage.getItem('FlyerShopperId'));
                } else {
                    flyerShopperId = 0;
                }
                if (!basketWithId) {
                    localStorage.setItem('BasketId', '0');
                }

                if (showFlyerNotFoundModal) toggleFlyerNotFoundModal(false);
                console.log(history);
                // console.log(params);
                const urlSearchParams = new URLSearchParams(history.location.search);
                const allSearchParams = Object.fromEntries(urlSearchParams.entries());

                const params = {
                    utm_campaign: allSearchParams.utm_campaign ? allSearchParams.utm_campaign : null,
                    utm_content: allSearchParams.utm_content ? allSearchParams.utm_content : null,
                    utm_medium: allSearchParams.utm_medium ? allSearchParams.utm_medium : null,
                    utm_source: allSearchParams.utm_source ? allSearchParams.utm_source : null,
                    utm_term: allSearchParams.utm_term ? allSearchParams.utm_term : null,

                }
                const isReversePages = !isMobile && !isPortraitView;
                dispatch(getRunTime(accountName, flyerName, flyerShopperId, isReversePages, params));
            } else {
                if (Boolean(history.location.search)) {
                    history.push(`/flyer/${accountName}/${flyerName}/notValidFlyer${history.location.search}`)
                } else {
                    history.push(`/flyer/${accountName}/${flyerName}/notValidFlyer`)
                }
            }
        }
    }, [flyerBranchBasic.data]);


    const changeMyListContent = (promosInMyList: PromosState[], promoWithBenefitItemsInMyList: IFreeItemsInPromo[]) => {
        if (myListForFlyer.data && myListForFlyer.data.myList) {
            const promosInBasket: PromosState[] = [...promosInMyList];
            let freeItemsForFlyerInBasket: IFreeItemsInPromo[] = [...promoWithBenefitItemsInMyList];
            myListForFlyer.data.myList.promos?.forEach((promoFromWMResponse: IFlyerRuntimePageSpotPromo) => {
                let comingItemsFromPromoWMResponse: ItemState[] = [];
                promoFromWMResponse.items.forEach((item: IFlyerRuntimePageSpotItem) => {
                    if (typeof item.qty === 'number') {
                        comingItemsFromPromoWMResponse.push({
                            spotItem: item,
                            count: item.qty
                        })
                    }
                })
                const selectedSpot = promosInBasket.find(promo => promo.promoId === promoFromWMResponse?.promoId);
                if (selectedSpot) {
                    for (let i = 0; i < comingItemsFromPromoWMResponse.length; i++) {
                        const selectedItem = selectedSpot.items.find(basketItem => basketItem.spotItem.id === comingItemsFromPromoWMResponse[i].spotItem.id);
                        if (selectedItem) {
                            selectedItem.count += comingItemsFromPromoWMResponse[i].count;
                            if (selectedSpot.promoSaleTypeCode === 80) {
                                const totalCountOfItemsWithoutBenefit = parseFloat(
                                    selectedSpot.items
                                        .reduce((acc, item) => {
                                            if (!item.spotItem.isBenefit) {
                                                return acc + item.count;
                                            }
                                            return acc
                                        }, 0)
                                        .toFixed(2)
                                )
                                // if (totalCountOfItemsWithoutBenefit % selectedSpot.promoBuyQty! === 0) {
                                const benefitItem = selectedSpot.items.find(basketItem => basketItem.spotItem.isBenefit);
                                // if (benefitItem && selectedSpot.promoBuyQty) {
                                if (benefitItem && selectedSpot.promoBuyQty && benefitItem.spotItem.id !== comingItemsFromPromoWMResponse[i].spotItem.id) {
                                    const isBenefitItemAlreadyInMyList = selectedSpot.items.some((item: ItemState) => item.spotItem.id === benefitItem.spotItem.id);
                                    if (isBenefitItemAlreadyInMyList) {
                                        benefitItem.count = Math.floor(totalCountOfItemsWithoutBenefit / selectedSpot.promoBuyQty);
                                    } else {
                                        selectedSpot.items.push({
                                            ...benefitItem,
                                            count: Math.floor(totalCountOfItemsWithoutBenefit / selectedSpot.promoBuyQty)
                                        });
                                    }
                                }
                                // }
                            }
                        } else {
                            selectedSpot.items.push(comingItemsFromPromoWMResponse[i]);
                            if (selectedSpot.promoSaleTypeCode === 80) {
                                const totalCountOfItemsWithoutBenefit = parseFloat(
                                    selectedSpot.items
                                        .reduce((acc, item) => {
                                            if (!item.spotItem.isBenefit) {
                                                return acc + item.count;
                                            }
                                            return acc
                                        }, 0)
                                        .toFixed(2)
                                )
                                // if (totalCountOfItemsWithoutBenefit % selectedSpot.promoBuyQty! === 0) {
                                const benefitItem = selectedSpot.items.find(basketItem => basketItem.spotItem.isBenefit);
                                // if (benefitItem && selectedSpot.promoBuyQty) {
                                if (benefitItem && selectedSpot.promoBuyQty && benefitItem.spotItem.id !== comingItemsFromPromoWMResponse[i].spotItem.id) {
                                    const isBenefitItemAlreadyInMyList = selectedSpot.items.some((item: ItemState) => item.spotItem.id === benefitItem.spotItem.id);
                                    if (isBenefitItemAlreadyInMyList) {
                                        benefitItem.count = Math.floor(totalCountOfItemsWithoutBenefit / selectedSpot.promoBuyQty)
                                    } else {
                                        selectedSpot.items.push({
                                            ...benefitItem,
                                            count: Math.floor(totalCountOfItemsWithoutBenefit / selectedSpot.promoBuyQty)
                                        });
                                    }
                                }
                                // }
                            }

                        }
                    }
                } else {
                    const promo: PromosState = {
                        ...promoFromWMResponse!,
                        items: comingItemsFromPromoWMResponse
                    }
                    promosInBasket.push(promo);
                    if (promo.promoSaleTypeCode === 80) {
                        const totalCountOfItemsWithoutBenefit = parseFloat(
                            promo.items
                                .reduce((acc, item) => {
                                    if (!item.spotItem.isBenefit) {
                                        return acc + item.count;
                                    }
                                    return acc
                                }, 0)
                                .toFixed(2)
                        )
                        // if (totalCountOfItemsWithoutBenefit % promo.promoBuyQty! === 0) {
                        const benefitItem = promo.items.find(basketItem => basketItem.spotItem.isBenefit);
                        if (benefitItem && promo.promoBuyQty) {
                            const isBenefitItemAlreadyInMyList = promo.items.some((item: ItemState) => item.spotItem.id === benefitItem.spotItem.id);
                            if (isBenefitItemAlreadyInMyList) {
                                benefitItem.count = Math.floor(totalCountOfItemsWithoutBenefit / promo.promoBuyQty)
                            } else {
                                promo.items.push({
                                    ...benefitItem,
                                    count: Math.floor(totalCountOfItemsWithoutBenefit / promo.promoBuyQty)
                                });
                            }
                        }
                        // }
                    }
                }
                let freeItemsForPromos: IFreeItemDto[] = [];
                const freePromoFromWMResponseWhichAlreadyExistInBasket = freeItemsForFlyerInBasket.find((promo: IFreeItemsInPromo) => promo.promoId === promoFromWMResponse?.promoId)
                if (promoFromWMResponse?.promoSaleTypeCode === 50 && freePromoFromWMResponseWhichAlreadyExistInBasket) {
                    const promoFromWMResponseExistInMyList = promosInBasket.find((promo: PromosState) => promo.promoId === promoFromWMResponse?.promoId);
                    if (promoFromWMResponseExistInMyList) {
                        promoFromWMResponseExistInMyList.items.forEach((item: ItemState) => {
                            const itemIsAlreadyExist = freePromoFromWMResponseWhichAlreadyExistInBasket.freeItems?.find((freeItem: IFreeItemDto) => freeItem.itemID === item.spotItem.id);
                            if (itemIsAlreadyExist && freePromoFromWMResponseWhichAlreadyExistInBasket.freeItems) {
                                freeItemsForPromos = [...freePromoFromWMResponseWhichAlreadyExistInBasket.freeItems].map((freeItem: IFreeItemDto) => {
                                    if (freeItem.itemID === itemIsAlreadyExist.itemID && typeof freeItem.itemCount === 'number') {
                                        freeItem.itemCount = item.count % (promoFromWMResponse?.promoBuyQty!) === 0 ? item.count / (promoFromWMResponse?.promoBuyQty!) : Math.floor(item.count / (promoFromWMResponse?.promoBuyQty!));
                                    }
                                    return freeItem;
                                })
                            } else {
                                if (promoFromWMResponse?.promoBuyQty && (item.count >= promoFromWMResponse?.promoBuyQty)) {
                                    freeItemsForPromos.push({
                                        itemCount: item.count % (promoFromWMResponse?.promoBuyQty!) === 0 ? item.count / (promoFromWMResponse?.promoBuyQty!) : Math.floor(item.count / (promoFromWMResponse?.promoBuyQty!)),
                                        itemID: item.spotItem.id,
                                        benefitItemCaption: item.spotItem.displayCaption1
                                    });
                                }
                            }
                        })

                    }
                }

                if (promoFromWMResponse?.promoSaleTypeCode === 51) {
                    const promoInBasketAfterChange = promosInBasket.find((promo: PromosState) => promo.promoId === promoFromWMResponse?.promoId);
                    if (promoInBasketAfterChange) {
                        const totalItemsCount = parseFloat(
                            promoInBasketAfterChange.items
                                .reduce((acc, item) => {
                                    return acc + item.count;
                                }, 0)
                                .toFixed(2)
                        )
                        if (promoFromWMResponse?.promoBuyQty && totalItemsCount !== 0) {
                            const cheapestItemInItemsArray = promoInBasketAfterChange.items.reduce((prev, curr) => {
                                return prev.spotItem.regularPrice < curr.spotItem.regularPrice ? prev : curr;
                            });
                            let newFreeItemsArray: IFreeItemDto[] = [];
                            promoInBasketAfterChange.items.forEach((item: ItemState) => {
                                if (promoFromWMResponse?.promoBuyQty! <= item.count) {
                                    newFreeItemsArray = [
                                        ...newFreeItemsArray,
                                        {
                                            itemCount: item.count % promoFromWMResponse?.promoBuyQty! === 0 ? item.count / promoFromWMResponse?.promoBuyQty! : Math.floor(item.count / (promoFromWMResponse?.promoBuyQty!)),
                                            itemID: item.spotItem.id,
                                            benefitItemCaption: item.spotItem.displayCaption1
                                        }]
                                }
                            });
                            const totalAlreadyCalculatedFreeItems = parseFloat(
                                newFreeItemsArray
                                    .reduce((acc, item) => {
                                        if (item) {
                                            return acc + item?.itemCount!;
                                        } else {
                                            return 0;
                                        }
                                    }, 0)
                                    .toFixed(2)
                            )
                            const numberOfNotCalculatedItems = totalItemsCount - totalAlreadyCalculatedFreeItems * promoFromWMResponse?.promoBuyQty;
                            if (numberOfNotCalculatedItems !== 0) {
                                const isCheapestItemExistInNewArray = newFreeItemsArray.some((freeItem: IFreeItemDto) => freeItem.itemID === cheapestItemInItemsArray.spotItem.id);
                                if (isCheapestItemExistInNewArray) {
                                    newFreeItemsArray.forEach((freeItem: IFreeItemDto) => {
                                        if (cheapestItemInItemsArray.spotItem.id === freeItem.itemID) {
                                            freeItem.itemCount! += numberOfNotCalculatedItems % promoFromWMResponse?.promoBuyQty! === 0 ? numberOfNotCalculatedItems / promoFromWMResponse?.promoBuyQty! : Math.floor(numberOfNotCalculatedItems / (promoFromWMResponse?.promoBuyQty!));
                                        }
                                    })
                                } else {
                                    newFreeItemsArray = [
                                        ...newFreeItemsArray,
                                        {
                                            itemCount: numberOfNotCalculatedItems % promoFromWMResponse?.promoBuyQty! === 0 ? numberOfNotCalculatedItems / promoFromWMResponse?.promoBuyQty! : Math.floor(numberOfNotCalculatedItems / (promoFromWMResponse?.promoBuyQty!)),
                                            itemID: cheapestItemInItemsArray.spotItem.id,
                                            benefitItemCaption: cheapestItemInItemsArray.spotItem.displayCaption1
                                        }
                                    ]
                                }
                            }
                            // if (JSON.stringify(newFreeItemsArray) !== JSON.stringify(freeItemsForPromos)) {
                            freeItemsForPromos = [...newFreeItemsArray];
                            // }
                        }

                    }
                }
                if (promoFromWMResponse?.promoSaleTypeCode === 50 || promoFromWMResponse?.promoSaleTypeCode === 51) {
                    // find freeItems object for flyer
                    if (freeItemsForFlyerInBasket) {
                        //find promo which has free item
                        const existedPromoInLocalStorage = freeItemsForFlyerInBasket.find((promoObj: IFreeItemsInPromo) => promoObj.promoId === promoFromWMResponse?.promoId)
                        if (existedPromoInLocalStorage) {
                            //checking if promo has freeItems
                            if (freeItemsForPromos!.length) {
                                freeItemsForPromos!.forEach((localStateFreeItem: IFreeItemDto) => {
                                    //then checked items which should adding to localStorage
                                    const freeItemExistInLocalStorage = existedPromoInLocalStorage.freeItems?.find((globalStateFreeItem: IFreeItemDto) => globalStateFreeItem.itemID === localStateFreeItem.itemID);
                                    if (freeItemExistInLocalStorage) {
                                        freeItemExistInLocalStorage.itemCount! = localStateFreeItem.itemCount!;
                                    } else {
                                        existedPromoInLocalStorage.freeItems = [...existedPromoInLocalStorage.freeItems!, localStateFreeItem!];
                                    }
                                });
                            } else {
                                existedPromoInLocalStorage.freeItems = freeItemsForPromos;
                            }
                        } else {
                            //if promo is NOT existed then put prev state for all promos and add new promo with current free items
                            freeItemsForFlyerInBasket = [...freeItemsForFlyerInBasket, {
                                promoId: promoFromWMResponse?.promoId,
                                freeItems: freeItemsForPromos
                            }]
                        }
                    } else {
                        //if we don't have in localStorage flyer state for free items
                        //then create new one
                        freeItemsForFlyerInBasket = [{
                            promoId: promoFromWMResponse?.promoId,
                            freeItems: freeItemsForPromos
                        }]
                    }
                }
            })
            //check promoSaleType and free items which related to promo 50 and 51
            dispatch(changeMyListItemsAndBenefitItemsAction({
                promos: promosInBasket,
                benefitItems: freeItemsForFlyerInBasket
            }));
            dispatch(changeMyListData(true));
            if (!isMobile) {
                dispatch(toggleBasket(true));
            }
        }
    }

    const onClickConfirm = (type: string) => {
        switch (type) {
            case 'add':
                changeMyListContent(myListState.promos, myListState.benefitItems);
                break;
            case 'replace':
                changeMyListContent([], []);
                break;
            default:
                break;
        }
        if (Boolean(history.location.search)) {
            history.push(`${history.location.pathname}${history.location.search}`);
        } else {
            history.push(history.location.pathname);
        }
        changeStatusOfMyListPopup(false);
    }

    const runChangeMyList = (isAllPopupClosed?: boolean) => {
        if (myListForFlyer.type && myListForFlyer.type.indexOf('GET_MY_LIST_FOR_FLYER_COMPLETE') > -1 && myListForFlyer.data?.myList && flyersBranch.data && (isAllPopupClosed ? isAllPopupClosed : !isShowDisclaimer && !isShowQuickTipsPopup)) {
            const promosInBasket: PromosState[] = myListState.promos;
            if (promosInBasket && promosInBasket.length) {
                changeStatusOfMyListPopup(true);
            } else {
                changeMyListContent(myListState.promos, myListState.benefitItems);
                if (Boolean(history.location.search)) {
                    history.push(`${history.location.pathname}${history.location.search}`);
                } else {
                    history.push(history.location.pathname);
                }
            }
        }
    }

    const onCloseDisclaimerPopup = (value: boolean) => {
        changeStatusOfDisclaimer(value);
        if (!value && flyersBranch.data && flyersBranch.data.flyerUiTexts?.isQuickTips) {
            changeStatusOfQuickTipsPopup(true);
        } else {
            runChangeMyList(true);
        }
    }

    const onCloseQuickTipsPopup = (value: boolean) => {
        changeStatusOfQuickTipsPopup(value);
        if (!value) {
            runChangeMyList(true);
        }
    }

    if (showFlyerNotFoundModal) {
        return <FlyerNotFoundModal/>
    }
    return (
        <>
            <Helmet>
                {/*<title>{flyersBranch.data?.caption!}</title>*/}
                {/*<meta name="description" content="Powered by xCircular XC-SHOPPER" />*/}
                <meta property="og:title" content={flyersBranch.data?.caption!}/>
                <meta property="og:description" content="Powered by XC Shopper"/>
                <meta property="og:image" content="https://flyers.xcshopper.com/ShopperLogo.png"/>
                <meta property="og:image:secure_url" content="https://flyers.xcshopper.com/ShopperLogo.png"/>
                <meta property="og:image:width" content="100"/>
                <meta property="og:image:height" content="100"/>
                <meta property="og:type" content="website"/>
                <meta name="theme-color" content={flyersBranch.data?.primaryColorRgb}/>
                <meta name="msapplication-TileColor" content={flyersBranch.data?.primaryColorRgb}/>
                <meta property="og:site_name" content={flyersBranch.data?.caption!}/>
                {/*<meta property="og:image:type" content="image/png"/>*/}
            </Helmet>
            <Layout isLoading={isLoading && (flyerBranchBasic.data ? flyerBranchBasic.data.isValid : true)}>
                <Switch>
                    <Route exact path="/flyer/:accountName?/:flyerName?/notValidFlyer"
                           render={() =>
                               <Suspense fallback={<Loading/>}>
                                   <ExpiredFlyerScreen/>
                               </Suspense>}
                    />
                </Switch>
                {
                    !isMobile && !isTablet && !isPortraitView && flyerBranchBasic.data?.isValid &&
                    <Suspense fallback={<Loading/>}>
                        <DesktopView/>
                    </Suspense>

                }
                {
                    (isMobile || isTablet || isPortraitView) && flyerBranchBasic.data?.isValid &&
                    <Suspense fallback={<Loading/>}>
                        <SmartphoneView/>
                    </Suspense>
                }
            </Layout>
            {isShowDisclaimer && flyersBranch.data && flyersBranch.data?.disclaimers && Boolean(flyersBranch.data?.disclaimers.isFlyerDisclaimer) &&
                <Suspense fallback={<></>}>
                    <DisclaimerPopup show={isShowDisclaimer} onClose={onCloseDisclaimerPopup}/>
                </Suspense>
            }
            {isShowQuickTipsPopup &&
                <Suspense fallback={<></>}>
                    <QuickTipsPopup show={isShowQuickTipsPopup} onClose={onCloseQuickTipsPopup}/>
                </Suspense>
            }
            {isShowChangeMyListPopup &&
                <Suspense fallback={<></>}>
                    <ChangeMyListPopup isShow={isShowChangeMyListPopup} onClickConfirm={onClickConfirm}/>
                </Suspense>
            }
            <ReduxErrorHandler/>
        </>
    )

};

export default ShopperMain;